// extracted by mini-css-extract-plugin
module.exports = {"margin_back":"NotEligibleFarmTruck_margin_back__2ysuE"};